
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, Tabs,
} from '@mui/material';

import Search from '@mui/icons-material/Search';
import PdfViewerComponent from '../../../components/PdfViewerComponent';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    FetchControls,
    DeterminePermissions,
    JSExportDialog,
    SharedService,
    ClientType
} from '../../../components/ComponentsLibrary';



const DocumentCaseDetail = forwardRef((props, ref) => {

    const {
        onComponentMount = () => { },
        PrimaryID,
        noCase,
        caseWorkflowID,
        HandleNotificationDialog,
        SetSelectedDoc,
        SelectedDoc,
        displayDocumentInternally = true,
        HandlePDFViewerError,
        persistViewerPreferences = false
    } = props;

    // Expose the method to the parent via ref
    useImperativeHandle(ref, () => ({
        onLoadDocumentsByCaseID,
    }));

    useEffect(() => {
        if (onComponentMount) {
            onComponentMount();
        }
    }, []);

    useEffect(() => {
        const testDoc = "Test Doc";
        console.log(testDoc);
    }, []);

    const errorFormName = "Case Detail - Documents";

    const caseDocsDataRefs = useRef([]); // Store DataGrid data persistently
    const pdfViewerRef = useRef(null);

    const [isPageLoading, setIsPageLoading] = useState(false);

    const [resultsExternalDocs, setExternalDocResults] = useState([]);
    const [paginationModel, setPaginationModel] = useState({ pageSize: 5, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });

    const [enableShowExternalDocument, setEnableShowExternalDocument] = useState(false);
    const [uncExternalDocumentUrl, setUncExternalDocumentUrl] = useState('');
    const [relatedBatchDocumentIds, setRelatedBatchDocumentIds] = useState(new Set());

    const [showMaxDocumentsMsg, setShowMaxDocumentsMsg] = useState(false)
    const [maxDocumentsToExport, setMaxDocumentsToExport] = useState(null);
    const [maxDocsExportMessage, setMaxDocsExportMessage] = useState('');
    const [showMaxDocReachedMsg, setShowMaxDocReachedMsg] = useState(false);
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [exportDialogOpen, setExportDialogOpen] = useState(false);
    const [resetJSExportDialog, setResetJSExportDialog] = useState(false);
    const [exportDialogContent, setExportDialogContent] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmationDialogContent, setConfirmationDialogContent] = useState([]);
    const [pendingEditorCloseAction, setPendingEditorCloseAction] = useState(null);
    const [JScapeServerUrl, setJScapeServerUrl] = useState("");
    const [notificationTimerValue, setNotificationTimerValue] = useState(3000);
    const [enableExport, setEnableExport] = useState(false);
    const { stateID, siteName } = SessionManager.GetDataFromSession("LoginUserInfoKey");
    const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    
    const [selectedRows, setSelectedRows] = useState([])
    const emailValidateRegex = useRef(null)

    const defaultPermissionsForFields = {
        clearFiltersBtn: { read: false, write: true, hide: false },
        exportDocumentsBtn: { read: false, write: false, hide: false },
        documentsDgrd: { read: false, write: true, hide: false },
        documentViewerVwr: { read: false, write: true, hide: false },
        docVwr1Editor: { read: false, write: true, hide: false },
        docVwr1ToolbarItems: { read: false, write: true, hide: false },
        docVwr2Editor: { read: false, write: true, hide: false },
        docVwr2ToolbarItems: { read: false, write: true, hide: false },
        docVwrSplitBtn: { read: false, write: true, hide: false },
        docVwrDeleteBtn: { read: false, write: true, hide: false },
        docVwrSaveBtn: { read: false, write: true, hide: false },
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);
   
    const documentViewerAccessPermissions = {
        viewOnlyAccess: true,
        editorAccess: formFieldAccess.docVwr1Editor,
        viewerToolbarItems: formFieldAccess.docVwr1ToolbarItems,
        // Split / Split All are only available on the Index, Re-Index and Manage Keywords document editors.
        splitButtonAccess: { hide: true },
        deleteButtonAccess: formFieldAccess.docVwrDeleteBtn,
        saveButtonAccess: formFieldAccess.docVwrSaveBtn,
    };

    const customDateFormat = "MM/DD/YYYY hh:mm A";

    useEffect(() => {
        const fetchFormFieldPermissions = async () => {
            try {
                const loginUserInfo = sessionService.getUser();
                const loginStateID = loginUserInfo ? loginUserInfo.stateID : -123456;
                const params = {
                    clientID: loginStateID,
                    formID: 40      // To-do: Modify Code - Hard-coded value of FormID: 40
                }
                const controlSecurityListApiData = await ApiManager.FetchControlsPermissions(params);
                const actualPermissionsForFields = DeterminePermissions(controlSecurityListApiData);
                setFormFieldAccess({ ...defaultPermissionsForFields, ...actualPermissionsForFields });
            } catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "fetchFormFieldPermissions", {});
            }
        };

        try {
            fetchFormFieldPermissions();
        }
        catch (error) {
            LoggerUtility.ManageErrorLogging(error, errorFormName, "fetchFormFieldPermissions - Page Load");
        }
    }, []);

    
    useEffect(() => {
        (async () => {
            const docLimitResult = await ApiManager.GetSettingsDetailValuesFromApi({
                settingsDetailIDList: ClientType.SettingsDetail.Document_Related__Export_Doc_Limit,
                yTracSiteID: stateID
            })
            setMaxDocumentsToExport(docLimitResult?.settingDetailsApiData?.[0]?.settingsDetailValue)
            
            const docLimitMsgResult = await ApiManager.getMessageContent({ stateID,
                messageContentID: ClientType.MessageContent.N_UI3542_Document_Export_Limit,
            })
            setMaxDocsExportMessage(docLimitMsgResult?.[0]?.messageText)

        })()
    }, [])
    
     useEffect(() => {
        if (showMaxDocReachedMsg) {
            HandleNotificationDialog({
                NotificationType: EnumUtility.NotificationType.Error,
                Title: "Error",
                Message: maxDocsExportMessage.replace("{0}", maxDocumentsToExport),
        }, notificationTimerValue, "right", true)
            setShowMaxDocReachedMsg(false);
        }
     }, [showMaxDocReachedMsg])
    
    useEffect(() => {
        const getSettingDetails = async() =>{
            const settingDetailIDs = [ClientType.SettingsDetail.Document_Related__JScape_Server_Host,
                ClientType.SettingsDetail.Document_Related__JScape_Server_Login_URI,
                ClientType.SettingsDetail.UI_Data_Validation__Email_Regex_Pattern,
                ClientType.SettingsDetail.UI_Miscellaneous__Error_Notification_Timer].join(", ");
            const params = {
                settingsDetailIDList: settingDetailIDs,
                yTracSiteID: stateID
            }
            const response = await ApiManager.GetSettingsDetailValuesFromApi(params);
            const settingValues = {}
            for (const result of response?.settingDetailsApiData ?? []){
                settingValues[ result?.settingsDetailID] = result?.settingsDetailValue
            }

            setJScapeServerUrl(settingValues[ClientType.SettingsDetail.Document_Related__JScape_Server_Host] + settingValues[ClientType.SettingsDetail.Document_Related__JScape_Server_Login_URI])
            emailValidateRegex.current = settingValues[ClientType.SettingsDetail.UI_Data_Validation__Email_Regex_Pattern];
            setNotificationTimerValue(settingValues[ClientType.SettingsDetail.UI_Miscellaneous__Error_Notification_Timer])
        }
        getSettingDetails();
    }, [])

    useEffect(() => {
        const getExportDialogContent = async () => {
            const params = {
                stateID,
                messageContentID: ClientType.MessageContent.N_UI3544_Export_Documents
            }
            const messageContentData = await ApiManager.GetMessageContentFromApi(params)
            const dialogContent= {
                ID: messageContentData?.messageContentID, Name:"ExportDocuments",
                Title: "Export Documents",//messageContentData?.messageContentName,
                Message: messageContentData?.messageText
            }
            return dialogContent  
        }
        if (showExportDialog) {
            (async () => {
                const exportDialogContent = await getExportDialogContent()
                setExportDialogContent(exportDialogContent);
                setExportDialogOpen(true);
                setShowExportDialog(false);//reset
            })()
        }
       
    }, [showExportDialog])

    const handleExportCheckboxClick = (event, params) => {
        const checked = event.target.checked;
        const updated = [...resultsExternalDocs]
        updated[params.row.rowIndex].export = checked
        //custom function to break away from the loop if export count more than max limit
        const selectedRows = (() => {
            let maxExceeded = false
            let selectedCount = 0
            let selectedDocs = []
            for (const row of updated) {
                if (row.export) selectedCount++;
                if (selectedCount > Number(maxDocumentsToExport)) {
                    maxExceeded = true
                    break;
                }
                if (row.export) {
                    selectedDocs = [...selectedDocs, row]
                }
            }
            return { maxExceeded, selectedCount, selectedDocs }
        })()

        //check if no of rows selected for export greater than maxDocumentsToExport
        const { maxExceeded, selectedCount, selectedDocs } = selectedRows
        const cleanedSelectedDocs = selectedDocs.map(({export: _export, rowIndex,...docData})=> docData)//use ifrequired
        // if one selected
        if (selectedCount > 0 && !maxExceeded)setShowMaxDocumentsMsg(true)
        if (selectedCount === 0)setShowMaxDocumentsMsg(false)
        //if more than maxDocumentsToExport rows selected for export show error message
        if (maxExceeded) {
            setShowMaxDocReachedMsg(true)
            setEnableExport(false)
        }
        else {
            console.log('[resultsExternalDocs] Updated via handleExportCheckboxClick:', updated);
            setExternalDocResults(updated)
            if (selectedCount > 0) {
                setSelectedRows(selectedDocs)
                setEnableExport(true)
            }
            else {
                setEnableExport(false)
            }
           
        }
    }

    const toFlatWorkflowDocuments = (workflowDocumentsResult) => {
        if (!workflowDocumentsResult) return [];

        if (Array.isArray(workflowDocumentsResult)) {
            if (workflowDocumentsResult.length > 0 && Array.isArray(workflowDocumentsResult[0])) {
                return workflowDocumentsResult.flat();
            }
            return workflowDocumentsResult;
        }

        if (Array.isArray(workflowDocumentsResult?.workflowDocuments)) {
            return workflowDocumentsResult.workflowDocuments;
        }

        if (Array.isArray(workflowDocumentsResult?.WorkflowDocuments)) {
            return workflowDocumentsResult.WorkflowDocuments;
        }

        return [];
    };

    const getRelatedBatchDocumentIds = async (workflowID) => {
        try {
            if (!workflowID || Number(workflowID) <= 0) {
                return new Set();
            }

            const workflowDocumentsResult = await ApiManager.GetWorkflowDocuments({
                caseWorkflowID: Number(workflowID),
                caseNumber: ""
            });

            const workflowDocuments = toFlatWorkflowDocuments(workflowDocumentsResult);

            const relatedIds = workflowDocuments
                .filter((doc) => Boolean(doc?.related ?? doc?.Related))
                .map((doc) => Number(doc?.batchDocumentID ?? doc?.BatchDocumentID))
                .filter((id) => Number.isFinite(id) && id > 0);

            return new Set(relatedIds);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "getRelatedBatchDocumentIds");
            return new Set();
        }
    };

    // Grid Columns: Test Data Documents for a Case Number
    const documentGridColumns = [
        {
            field: 'related',
            headerName: 'Workflow Related',
            minWidth: 150,
            renderCell: (params) => (
                <Checkbox
                    checked={Boolean(params.value)}
                    disabled
                    color="primary"
                />
            )
        },
        { field: 'createdTS', headerName: 'Scan Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 180 },
        { field: 'indexTS', headerName: 'Index Date', type: 'dateTime', valueFormatter: (value) => value && UtilityLibrary.formatDate(value, customDateFormat), minWidth: 180 },
        { field: 'documentGroupTypeName', headerName: 'Group', minWidth: 180 },
        { field: 'documentTypeName', headerName: 'Type', minWidth: 200 },
        { field: 'documentSource', headerName: 'Source', minWidth: 120 },
        { field: 'batchDocumentID', headerName: 'ID', minWidth: 80 },
        {
            field: 'export', headerName: 'Export', minWidth: 80, renderCell: (params) => (
            <Checkbox
                    id="exportChk"
                    name="exportChk"
                    checked={!!params.value}
                    onChange={(e) => handleExportCheckboxClick(e, params)}
                    color="primary"
                    disabled={!(formFieldAccess.exportDocumentsBtn?.write ?? false) || !maxDocumentsToExport} //Disable if user doesnt have permission or till max document export loads
            />)
        }
    ];

    // Add an index and export column to each row
    const resultsExternalDocsWithIndex = (currentGridData, relatedIds = relatedBatchDocumentIds) => {
        const gridData = currentGridData ? currentGridData : [];
        const returnData = gridData.map((row, index) => ({
            ...row,
            rowIndex: index, // Add rowIndex property
            export: row.export ?? false,
            related: Boolean(row.related ?? row.Related) || relatedIds.has(Number(row.batchDocumentID)),
        }));
        console.log('[resultsExternalDocs] Updated via resultsExternalDocsWithIndex:', returnData);
        setExternalDocResults(returnData);

        return returnData;
    };



    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const assignAllCaseDataFromSessionToRefs = () => {
            try {
                // Retrieve session data
                const storedData = SessionManager.GetDataFromSession(SessionManager.CaseInformationKey);
                console.log('[caseDocsDataRefs] Assigning from session - storedData:', storedData);
                if (storedData.length > 0) {
                    storedData.forEach((record) => {
                        const primaryKey = record.caseNumber;
                        if (!primaryKey) return; // Skip records without a primary key
    
                        // Initialize the dataRefs object for this record
                        if (!caseDocsDataRefs.current[primaryKey]) {
                            caseDocsDataRefs.current[primaryKey] = { caseDocs: record.caseDocs || [] };
                            console.log('[caseDocsDataRefs] Populated from session for caseNumber:', primaryKey, 'docs:', record.caseDocs);
                        }    
                    });
                }
            }
            catch (error) {
                throw LoggerUtility.ProcessErrorData(error, "assignAllCaseDataFromSessionToRefs", {});
            }
        };

    const onLoadDocumentsByCaseID = async () => {
        try {
            assignAllCaseDataFromSessionToRefs();
            const caseID = PrimaryID;
            const effectiveWorkflowID = caseWorkflowID || (noCase ? caseID : null);
            
            // Initialize the case docs data reference if it doesn't exist
            if (!caseDocsDataRefs.current[caseID]) {
                caseDocsDataRefs.current[caseID] = { caseDocs: [] };
            }
            
            // Load documents if not already loaded or if empty
            if (!caseDocsDataRefs.current[caseID].caseDocs || caseDocsDataRefs.current[caseID].caseDocs.length === 0) {
                let caseDocsData = [];
                console.log("Loading documents for caseID:", caseID, "noCase:", noCase);
                if(!noCase) {
                    caseDocsData = await caseDataService.getCaseDocsByCaseID(caseID);
                    console.log('[caseDocsDataRefs] Fetched from getCaseDocsByCaseID API:', caseDocsData);
                } else {
                    caseDocsData = await caseDataService.getCaseDocumentsFromApiByCaseWorkflowID(caseID);
                    console.log("[caseDocsDataRefs] Documents loaded for no-case workflowID:", caseID, "Documents:", caseDocsData);
                }
                console.log("[caseDocsDataRefs] Final CASEDOCSDATA-------", caseDocsData);
                caseDocsDataRefs.current[caseID].caseDocs = caseDocsData || [];
                console.log('[caseDocsDataRefs] Stored in ref for caseID:', caseID, 'Data:', caseDocsDataRefs.current[caseID]);
            }

            const relatedIds = await getRelatedBatchDocumentIds(effectiveWorkflowID);
            setRelatedBatchDocumentIds(relatedIds);

            console.log('[caseDocsDataRefs] About to pass to resultsExternalDocsWithIndex:', caseDocsDataRefs.current[caseID].caseDocs);
            resultsExternalDocsWithIndex(caseDocsDataRefs.current[caseID].caseDocs || [], relatedIds);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "onLoadDocumentsByCaseID");
        }
    };

    const setExternalDocumentInViewer = async (batchDocumentID, completeDocumentPath) => {
        try {
            //if (testDocLoad) { setDocumentUrl('document-003.pdf'); } else { setDocumentUrl('document-004.pdf'); }

            const docsUncAPI = ApiManager.DocumentUncApiUrl;
            const { hasError, isFileExists, fileUrl, errorList } = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            //const fileUrl = await DocumentUtility.GetFileUncPath(docsUncAPI, completeDocumentPath);
            setUncExternalDocumentUrl(fileUrl);
            setEnableShowExternalDocument(true);
            return { fileUrl, hasError }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "setDocumentInViewer", {});
        }
    }


    const handleSelectExternalDocsFromGrid = async (params) => {
        setIsPageLoading(true);
        try {
            await simulateAsyncDelay();
            const {batchDocumentID, batchID, documentUNCPath} = params.row
            const { hasError, fileUrl } = await setExternalDocumentInViewer(batchDocumentID, documentUNCPath);
            SetSelectedDoc({ ...params.row, uncExternalDocumentUrl: fileUrl });
           
            if (hasError) {
                const errorMessage = "Failed to retrieve document from the path"
                HandlePDFViewerError(errorMessage, {batchID, batchDocumentID})
            }           
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSelectExternalDocsFromGrid");
        }
        finally { setIsPageLoading(false); }
    }

    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };

    const handleExportDocuments = async() => {
        try {
            setShowExportDialog(true)
        }
        catch (error){
            
        }
    }

    const handleCloseExportDialog = useCallback(() => {
        try {
            // Close JS export dialog and reset its contents
            setExportDialogOpen(false);
            setResetJSExportDialog(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleCloseNotificationDialog", {});
        }
    }, []);

    const handleConfirmationDialog = (dialogContent) => {
        setConfirmationDialogContent(dialogContent);
        setConfirmDialogOpen(true);
    };

    const handleCloseConfirmDialog = () => {
        setPendingEditorCloseAction(null);
        setConfirmDialogOpen(false);
    };

    const handleDialogConfirmAction = (dialogContentID) => {
        switch (dialogContentID) {
            case EnumUtility.ConfirmDialogType.CloseDocumentEditor.ID:
                if (pendingEditorCloseAction) {
                    pendingEditorCloseAction();
                    setPendingEditorCloseAction(null);
                }
                break;

            default:
                break;
        }

        setConfirmDialogOpen(false);
    };

    const handleDocumentEditorCloseRequest = ({ hasSelectedPages, closeEditor }) => {
        if (!hasSelectedPages) {
            closeEditor();
            return false;
        }

        setPendingEditorCloseAction(() => closeEditor);
        handleConfirmationDialog(EnumUtility.ConfirmDialogType.CloseDocumentEditor);
        return false;
    };


      const handleExportDialogAction = async (emailAddrsString) => {
          try {
            //Removes any space including new line and returns comma delimited email ids as a string
            const cleanEmailString = emailAddrsString.replaceAll(';', ',').replace(/\s+/g, '').replace(/,+$/, '').toLowerCase();
            const emails = cleanEmailString.split(',');
            
            //domain validation and email send
            const postData = {
                emails,
                serverUrl: JScapeServerUrl, 
                boardedSiteName: siteName,
                caseNumber: PrimaryID,
                referToED: selectedRows,//use selectedRows instaed and get docs from the externsldocs state
                ytracSiteID: stateID,
                masterServerDBSchema: masterServerDBSchema
            }
            const {success, message, statusCode } = await ApiManager.ExportDocument(postData)
            //if error show popup
            if (!success) {
                let timerValue = notificationTimerValue;
                let backdropDismissal = true;
                if (statusCode === "INVALID_DOMAINS") {
                    timerValue = 0;
                    backdropDismissal = false;
                }
                HandleNotificationDialog(
                {
                    NotificationType: EnumUtility.NotificationType.Error,
                    Title: "Error",
                    Message: message.replace(/\\n/g, "\n"),
                }, timerValue, "right", backdropDismissal)
            }
            else {
                //success //TODO success popup?
                setEnableExport(false)
                // Close JS export dialog and and reset its contents
                setExportDialogOpen(false);
                setResetJSExportDialog(true);
                setSelectedRows([])
                handleClearSelection()
            }
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleExportDialogAction");
        }
    };
    
    
    const emailValidator = (emailAddrsString) =>
    {
        let areEmailAddrsValid = false;
        const emails = emailAddrsString.split(",");
        try
        {
            for (const email of emails)
            {
                if (emailValidateRegex.current) {
                    //string regexPattern = @"^[a-zA-Z0-9._'%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";
                    const regex = new RegExp(emailValidateRegex.current)
                    const isEmailValid = regex.test(email);
                    if (isEmailValid)
                    {
                        areEmailAddrsValid = true;
                    }
                    else {
                        areEmailAddrsValid = false;
                        break;
                    }
                }
                //tODO what if regex is empty
            }
            return areEmailAddrsValid;
        }
        catch (Exception)
        {
            areEmailAddrsValid = false;
            return areEmailAddrsValid;
        }
    }
    const handleClearSelection = () => {
        setExternalDocResults((prev) => {
            const updated = prev.map(doc => ({...doc, export : false}));
            console.log('[resultsExternalDocs] Updated via handleClearSelection:', updated);
            return updated;
        })
        setShowMaxDocumentsMsg(false)
    }

    const PDFErrorInterface = (errorMessage) => {
        HandlePDFViewerError(errorMessage, SelectedDoc)
    }

     const handleCopyPathButtonPress = async () => {
        try{
          const loginUserInfo = sessionService.getUser();
          const { stateID, siteID, legacyUserID: userID } = loginUserInfo || {};
          // Get temp file set det
          const setDetailIDs = [ClientType.SettingsDetail.DMS_Scanning__Copy_Link_Temp_Path,
          ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER]
          const params = {
            settingsDetailIDList: setDetailIDs.join(","),
            yTracSiteID: stateID
          }
          const settingDetails = await ApiManager.GetSettingsDetailValuesFromApi(params); 
          const messageContentData = await SharedService.getMessageContent(ClientType.MessageContent.N_UI7057_Document_Path_Copied);
          const timerValue = (settingDetails?.settingDetailsApiData.find(
            value => parseInt(value.settingsDetailID) === ClientType.SettingsDetail.UI_Miscellaneous__Success_Notification_TIMER)?.settingsDetailValue || 3) * 1000;
          await SharedService.handleCopyPathButtonPress(SelectedDoc, uncExternalDocumentUrl, settingDetails, { stateID, siteID, userID }, masterServerDBSchema);
           // Display notification dialog
          HandleNotificationDialog({ NotificationType: "success", Message: messageContentData?.messageText}, timerValue, "top-right"
          )
        }
        catch (err) {
          HandleNotificationDialog({ NotificationType: "error", Message: 'Error occured while coping the file path' }, 3000, "top-right"
          );
        }   
      } 

    //=======================================================================
    //  - End
    //=======================================================================


    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================


    //=======================================================================
    // Tabs Feature - End
    //=======================================================================



    const mainDocumentContent = (
        <div style={{ padding: '2px', width: '100%' }}>            {
                resultsExternalDocs.length > 0 ? (
                    <div>{/* Middle Section - Document Grid and Buttons  */}
                        <Paper elevation={2} className="document-grid" sx={{ boxShadow: "none" }}>
                            <div className="yt-button-container">
                                <div className="text-wrapper-header-2" style={{ paddingLeft: '10px' }}>Documents:</div>
                                {showMaxDocumentsMsg && maxDocumentsToExport && (<div style={{ color: "red", marginLeft: "8px" }}>
                                    <span>Limit to {maxDocumentsToExport} documents at a time.</span>
                                </div>)}
                                
                                <div className="document-grid-header">
                                    {!(formFieldAccess.clearFiltersBtn?.hide ?? false) && (
                                        <Button id="clearFiltersBtn" name="clearFiltersBtn" variant="text" color="ywTextBlue" className="clear-filters-btn" onClick={handleGridClearFilters} disabled={!(formFieldAccess.clearFiltersBtn?.write ?? true)}>CLEAR FILTERS</Button>
                                    )}
                               
                                    {!(formFieldAccess.exportDocumentsBtn?.hide ?? false) && (
                                        <Button id="exportDocumentsBtn" name="exportDocumentsBtn" variant="text" color="ywTextBlue" className="export-doc-btn" onClick={handleExportDocuments} disabled={!(formFieldAccess.exportDocumentsBtn?.write ?? false) || !enableExport}>EXPORT DOCUMENTS</Button>
                                    )}
                                </div>    
                               
                            </div>
                            {!(formFieldAccess.documentsDgrd?.hide ?? false) && (
                                <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', height: "100%", width: "100%", overflowX: "auto" }}>
                                    <DataGridPremium
                                        id="documentsDgrd"
                                        name="documentsDgrd"
                                        rows={resultsExternalDocs}
                                        columns={documentGridColumns}
                                        rowsPerPageOptions={[5]}
                                        pagination
                                        pageSizeOptions={[5, 10, 15, 20, 25]}
                                        paginationModel={paginationModel} // Controlled pagination
                                        onPaginationModelChange={setPaginationModel} // Handle page changes   
                                        getRowId={(row) => `${row.batchDocumentID}-${row.rowIndex}`}
                                        onRowClick={handleSelectExternalDocsFromGrid}
                                        filterModel={gridFilterModel}
                                        onFilterModelChange={handleGridFilterChange}
                                        autosizeOnMount
                                        autosizeOptions={{
                                            includeHeaders: true,
                                            includeOutliers: true,
                                            expand: true
                                        }}
                                        sx={{
                                            "& .MuiDataGrid-row:hover": {
                                              cursor: "pointer"
                                            },
                                            ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                                              "margin-top": "1em",
                                              "margin-bottom": "1em"
                                            },
                                            "& .MuiDataGrid-virtualScroller": { overflowX: "auto", overflowY: "auto" }
                                          }}
                                    />
                                </div>
                            )}
                        </Paper>
                    </div>
                )
                    :
                    <div className="text-wrapper-subtitle">No document found for the Case!</div>
            }
            {/* Bottom Section - Document Viewer*/}
            {displayDocumentInternally &&
                (enableShowExternalDocument) && (
                (uncExternalDocumentUrl) &&
                <Paper elevation={2}
                    className="document-viewer"
                    sx={{ boxShadow: "none", height: "70vh", minHeight: 500 }}>
                    {!(formFieldAccess.documentViewerVwr?.hide ?? false) && (
                        <div style={{ width: "100%", height: "100%" }}>
                            <PdfViewerComponent
                                ref={pdfViewerRef}
                                origin="CaseInformation"
                                id="documentViewerBatchVwr"
                                name="documentViewerBatchVwr"
                                key={uncExternalDocumentUrl}
                                document={uncExternalDocumentUrl}
                                viewerAccessPermissions={documentViewerAccessPermissions}
                                style={{ width: '100%' }}
                                onCopyPathButtonPress={handleCopyPathButtonPress}
                                onPDFReadError={PDFErrorInterface}
                                persistViewerPreferences={persistViewerPreferences}
                                viewerPreferencesSessionKey="WorkflowIndexViewerPreferences"
                                onEditorCloseRequest={handleDocumentEditorCloseRequest}
                            />
                        </div>
                    )}
                </Paper>
            )}
        </div>
    );



    return (
        <div style={{ height: '100%' }}>
            {mainDocumentContent}
            <ConfirmationDialog
                openConfirmation={confirmDialogOpen}
                dialogContent={confirmationDialogContent}
                onCloseConfirmation={handleCloseConfirmDialog}
                onConfirmDialog={(param) => handleDialogConfirmAction(param)}
            />
            <JSExportDialog
                openDialogBox={exportDialogOpen}
                dialogContent={exportDialogContent}
                onCloseDialog={handleCloseExportDialog}
                onConfirmDialog={(param) => handleExportDialogAction(param)}
                validateEmails={emailValidator}
                onClearDialog={resetJSExportDialog}
                onResetDone={() => setResetJSExportDialog(false)}
            />
        </div>
    );
});

export default DocumentCaseDetail;






    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


    


    //=======================================================================
    //  - Begin
    //=======================================================================

    //=======================================================================
    //  - End
    //=======================================================================


